export interface IMissingVoucherConsent {
    donorId: number,
    alias: string,
    donationDate: string,
    voucherHoldersMissingConsent: number
}